// Elevar helpers - centralized functions for Elevar integration

const ELEVAR_PLAN_PLACEHOLDER_IMAGE = 'https://www.myollie.com/og-image.png';

const hashCode = str => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
};

export const formatElevarPrice = value => {
  if (!value && value !== 0) return undefined;
  const sanitized = `${value}`.replace(/[^0-9.]/g, '');
  return sanitized || undefined;
};

export const formatElevarAddonPrice = candidate => {
  if (candidate === undefined || candidate === null || candidate === '')
    return '0.00';
  const num = Number(candidate);
  return Number.isFinite(num) ? num.toFixed(2) : `${candidate}`;
};

export const sanitizePlanIdentifier = id => {
  if (id === undefined || id === null) return undefined;
  const stringified = `${id}`;
  return /^\d+$/.test(stringified)
    ? stringified
    : `${Math.abs(hashCode(stringified))}`;
};

export const buildSelectedElevarMealPrepProduct = ({
  mealPrepProducts,
  mealPrepTypes,
  selectedMealPrepType,
  selectedFreshRecipes,
  selectedBakedRecipes,
  getConfigFromRecipes,
}) => {
  const planTypeData = mealPrepProducts?.find(
    planType => planType.value === selectedMealPrepType,
  );
  if (!planTypeData) return null;
  const { img, ...planWithoutImg } = planTypeData;

  const pricing = getConfigFromRecipes(
    selectedMealPrepType,
    selectedFreshRecipes,
    selectedBakedRecipes,
  );

  const position = mealPrepTypes.findIndex(
    planType => planType.value === selectedMealPrepType,
  );

  return {
    ...planWithoutImg,
    price: formatElevarPrice(
      pricing?.discountedPrice ||
        pricing?.price ||
        planTypeData.pricingInfo?.price,
    ),
    discountedPrice: formatElevarPrice(pricing?.discountedPrice),
    compare_at_price: formatElevarPrice(planTypeData.pricingInfo?.price),
    product_id: planTypeData.sku || planTypeData.value,
    sku: planTypeData.sku || planTypeData.value,
    variant_id: planTypeData.sku || planTypeData.value,
    combination_id: pricing?.combination_id || planTypeData.combination_id,
    image: ELEVAR_PLAN_PLACEHOLDER_IMAGE,
    position: position >= 0 ? position + 1 : undefined,
  };
};

export const buildElevarAddonProduct = (
  sku,
  addons,
  selectedAddons,
  skuMap = {},
) => {
  const addon =
    addons.find(item => (item.sku || item.value) === sku) ||
    selectedAddons[sku] ||
    {};
  const resolvedSku = skuMap[addon.sku] || addon.sku || sku;
  const name =
    addon.productName || addon.title || addon.name || addon.label || sku;
  const priceCandidate =
    addon.pricingInfo?.discountedPrice ??
    addon.discountedPrice ??
    selectedAddons[sku]?.discountedPrice ??
    addon.price ??
    addon.pricingInfo?.price;
  const compareAtCandidate =
    addon.pricingInfo?.price ??
    addon.pricingInfo?.compareAtPrice ??
    addon.compare_at_price ??
    addon.compareAtPrice ??
    addon.price ??
    addon.addonPrice ??
    selectedAddons[sku]?.price ??
    priceCandidate;

  const price = formatElevarAddonPrice(priceCandidate);
  const compareAtPrice = formatElevarAddonPrice(compareAtCandidate);

  const skuValue = addon.variant || addon.sku || resolvedSku;

  return {
    product_id: skuValue,
    variant_id: skuValue,
    sku: skuValue,
    productName: name,
    name,
    price,
    compare_at_price: compareAtPrice,
    image: '',
    productType: addon.productType || addon.category || 'Addon',
    category: addon.category || 'Addon',
  };
};
